var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlickLogo20LivePositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1076 506",
    style: {
      enableBackground: "new 0 0 1076 506"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#821BB8;}\n\t.st1{fill:#DCDCDC;}\n\t.st2{fill:#FBFBFB;}\n\t.st3{fill:#5F1486;}\n\t.st4{fill:#831BB8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.9,213.3l188.8-14.9c30.2,0,54.6,24.4,54.6,54.6v0c0,30.2-24.4,39.7-54.6,39.7l-188.8,14.9 c-30.2,0-54.6-24.4-54.6-54.6v0C109.3,222.8,133.8,213.3,163.9,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.3,214.4l67.5-67.5c26.9-26.9,49.4-58,66.5-92.1l0,0l12.8,12.8l0,0c42.6,42.6,42.6,111.8,0,154.4 l-69.5,69.5c-21.3,21.3-55.9,21.3-77.2,0l0,0C104,270.3,104,235.7,125.3,214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M391.3,291.6l-67.5,67.5c-26.9,26.9-49.4,58-66.5,92.1v0l-12.8-12.8l0,0c-42.6-42.6-42.6-111.8,0-154.4 l69.5-69.5c21.3-21.3,55.9-21.3,77.2,0l0,0C412.7,235.7,412.7,270.3,391.3,291.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "918.2,270.3 966.7,198.4 923.6,198.4 875.1,270.3 923.6,342.2 966.7,342.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M472.7,298c10.2,9.6,31.1,19.2,48.6,19.2c16,0,23.6-5.5,23.6-14.3c0-9.9-12.2-13.4-28.2-16.6 c-24.1-4.7-55.3-10.5-55.3-43.9c0-23.6,20.7-44.2,57.6-44.2c23.9,0,42.8,8.1,56.5,19.2l-14.5,25.3c-8.4-9-24.4-16.3-41.6-16.3 c-13.4,0-22.1,4.9-22.1,13.1c0,8.7,11.1,11.9,26.8,15.1c24.2,4.7,56.5,11.1,56.5,46c0,25.9-21.8,45.1-60.8,45.1 c-24.4,0-48-8.1-62.9-21.8L472.7,298z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M630.7,148.1L630.7,148.1l0,194.1h-37V185.1C593.8,164.7,610.3,148.1,630.7,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M875.1,148.1L875.1,148.1l0,194.1h-37V185.1C838.2,164.7,854.7,148.1,875.1,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M644.4,158.2c0-12.2,10.2-22.1,22.1-22.1c12.2,0,22.1,9.9,22.1,22.1c0,12.2-9.9,22.1-22.1,22.1 C654.6,180.4,644.4,170.5,644.4,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M685.2,198.4L685.2,198.4l0,143.8h-37l0-106.9C648.2,214.9,664.8,198.4,685.2,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M772,198.2c28.8,0,46.3,12.5,55.6,25.6l-24.2,22.4c-6.7-9.6-16.9-15.1-29.7-15.1c-22.4,0-38.1,16.3-38.1,40.7 s15.7,41,38.1,41c12.8,0,23-5.8,29.7-15.1l24.2,22.4c-9.3,13.1-26.8,25.6-55.6,25.6c-43.4,0-74.5-30.6-74.5-73.9 C697.5,228.7,728.6,198.2,772,198.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlickLogo20LivePositive);
export default __webpack_public_path__ + "static/media/Slick-Logo2-0_Live_Positive.856816b3e8e291795a4b886e3189b20d.svg";
export { ForwardRef as ReactComponent };